// src/redux/manualgatepassSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_manualgatepass,
  add_manualgatepass,
  update_manualgatepass,
  delete_manualgatepass,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  manualgatepass: [],
  manualgatepasslist: [],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
     user: "",
        name: "",
        mobile: "",
        relation_with_student: "",
        valid_duration:"30 min",
        status: "Pending",
        remarks: "",
        purpose: "",
  },
};

// Async Thunks for API Calls
export const fetchmanualgatepass = createAsyncThunk(
  "manualgatepass/fetchmanualgatepass",
  async (
    { page, page_size, school_id, search, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_manualgatepass(
        page,
        page_size,
        school_id,
        search,
        token,
        signal
      );

      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createmanualgatepass = createAsyncThunk(
  "manualgatepass/createmanualgatepass",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_manualgatepass(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatemanualgatepass = createAsyncThunk(
  "manualgatepass/updatemanualgatepass",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_manualgatepass(
        data,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletemanualgatepass = createAsyncThunk(
  "manualgatepass/deletemanualgatepass",
  async ({ ids, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_manualgatepass(
        { ids },
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// manualgatepass Slice
const manualgatepassSlice = createSlice({
  name: "manualgatepasss",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        user: "",
        name: "",
        mobile: "",
        relation_with_student: "",
        valid_duration:"30 min",
        status: "Pending",
        remarks: "",
        purpose: "",
      };
    },
    setmanualgatepass(state, action) {
      state.manualgatepass = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch manualgatepass
      .addCase(fetchmanualgatepass.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchmanualgatepass.fulfilled, (state, action) => {
        state.loading = false;
        state.manualgatepass = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchmanualgatepass.rejected, (state, action) => {
        state.loading = false;
        state.manualgatepass = [];
        state.error = action.payload;
      })

      // Add manualgatepass
      .addCase(createmanualgatepass.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createmanualgatepass.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createmanualgatepass.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage =
          action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);
        state.IsEditing = false;
      })
      // Update manualgatepass
      .addCase(updatemanualgatepass.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatemanualgatepass.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatemanualgatepass.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage =
          action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);
      })
      // Delete manualgatepass
      .addCase(deletemanualgatepass.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletemanualgatepass.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletemanualgatepass.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setmanualgatepass,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
} = manualgatepassSlice.actions;
export default manualgatepassSlice.reducer;



